import { useEffect } from "react";
import { useRouter } from "next/router";
import { useServiceAgreementModal } from "./useServiceAgreementModal";
import { ACCEPTED_LATEST_AGREEMENT, PUBLIC_PATHS } from "@aspen/libs";

export const useGlobalAgreementCheck = () => {
  const router = useRouter();
  const { visible, loading, showModal, handleAgree, handleClose } = useServiceAgreementModal();

  useEffect(() => {
    try {
      const currentPath = router.pathname;
      const isPublicPath = Object.values(PUBLIC_PATHS).some(path => currentPath.startsWith(path));

      if (isPublicPath) {
        return;
      }

      const acceptedValue = sessionStorage.getItem(ACCEPTED_LATEST_AGREEMENT);

      if (acceptedValue === "false") {
        showModal();
      }
    } catch (error) {
      // 静默失败，sessionStorage 异常时不显示弹窗，避免影响用户使用
      console.error("Failed to check agreement status:", error);
    }
  }, [router.pathname]);

  return {
    visible,
    loading,
    handleAgree,
    handleClose,
  };
};
